// eslint-disable-next-line import/prefer-default-export
export enum CompletionCriteriaType {
  POINTS = 'points',
  ASSIGNMENTS = 'assignments',
  TODOS = 'todos',
}
